import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BLOCKS } from '@contentful/rich-text-types';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useRichText } from '../../../utils/richText';
import CTAsList from '../../common/CTAsList';
import { StepsHeaderContainer } from './styles';
export const stepsHeaderOptions = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return _jsx("div", { children: children });
        },
    },
};
const ItemsHeader = ({ direction = 'column', titleLevel = 2, maxWidth = 745, CTAs, title, body, bodyLong, subtitle, }) => {
    const renderedBodyLong = useRichText(bodyLong, stepsHeaderOptions);
    if (!title && !body && !subtitle && !bodyLong && !(CTAs === null || CTAs === void 0 ? void 0 : CTAs.length))
        return _jsx(_Fragment, {});
    return (_jsxs(StepsHeaderContainer, { "$direction": direction, style: { maxWidth }, children: [!!title && (_jsx(Typography.Title, { level: titleLevel, style: { flex: 2 }, children: title })), !!subtitle && (_jsx(Typography.Title, { level: 3, elementTheme: "h6", children: subtitle })), (!!body || bodyLong) && (_jsx(Typography, { style: { flex: 3 }, elementTheme: "body1", children: !!bodyLong ? renderedBodyLong : !!body ? body : '' })), _jsx(CTAsList, { CTAs: CTAs })] }));
};
export default ItemsHeader;
